import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        images: [],
        loginModal: false,
        loggedIn: false,
        estimateModal: false
    },
    mutations: {
        getImages(state, payload) {
            state.images.push(payload)
        },
        toggleLogin(state, payload) {
            state.loginModal = payload
        },
        toggleEstimate(state, payload) {
            state.estimateModal = payload
        },
        logged(state, payload) {
            state.loggedIn = payload
        }

    },
    actions: {},
    modules: {}
})